import { enum_EDPPREPARE_FORM_MODE } from "../../common/Dictionaries";
import { 
	SET_FIRE_LOAD,
	SET_NOTIFICATION_TASKS_LIST,
	SET_NOTIFICATION_TASKS_LIST_FILTRED,
	SET_NOTIFICATION_TASKS_FOCUSEDITEM,
	SET_NOTIFICATION_TASKS_SELECTEDITEMS,
	SET_NOTIFICATION_TASKS_MENUITEMS
} from "../actions/NotificationTasks/actions";

const initialState = {
	_fireLoad: false,
	_notificationTaskDataList: null,
	_notificationTaskDataListFiltred: null,
	_focusedItem: null,
	_selectedNotificationTasks: null,
	_notificationTaskMenuData: null
};

const notificationTaskReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FIRE_LOAD:
			return {
				...state,
				_fireLoad: action.payload
			};
		case SET_NOTIFICATION_TASKS_LIST:
			return {
				...state,
				_notificationTaskDataList: action.payload
			};
		case SET_NOTIFICATION_TASKS_LIST_FILTRED:
			return {
				...state,
				_notificationTaskDataListFiltred: action.payload
			};
		case SET_NOTIFICATION_TASKS_FOCUSEDITEM:
			return {
				...state,
				_focusedItem: action.payload
			};
		case SET_NOTIFICATION_TASKS_SELECTEDITEMS:
			return {
				...state,
				_selectedNotificationTasks: action.payload
			};
		case SET_NOTIFICATION_TASKS_MENUITEMS:
			return {
				...state,
				_notificationTaskMenuData: action.payload
			};
		default:
			return state;
	}
};



export default notificationTaskReducer;